import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EmergingSecurityEventModalComponent } from '../emerging-security-event-modal/emerging-security-event-modal.component';
import { CreateEseFromTemplateModalComponent } from '../create-ese-from-template-modal/create-ese-from-template-modal.component';

@Component({
  selector: 'cygov-ese-chooser-modal',
  templateUrl: './ese-chooser-modal.component.html',
  styleUrls: ['./ese-chooser-modal.component.scss'],
  standalone: false,
})
export class EseChooserModalComponent {
  @Input() entity: any;
  @Input() isFromVendorListing: boolean = false;
  @Input() selectedVendors: any[] = [];
  @Input() currentUser: string = '';
  @Output() closeEvent = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  ngbModalOptionsESEModal: NgbModalOptions = {
    size: 'sm',
    windowClass: 'emerging-security-event-modal-window',
    backdropClass: 'emerging-security-event-modal-backdrop',
    backdrop: 'static',
  };

  ngbModalOptionsCreateFromTemplate: NgbModalOptions = {
    size: 'sm',
    windowClass: 'create-ese-from-template-modal-window',
    backdropClass: 'create-ese-from-template-modal-backdrop',
    backdrop: 'static',
  };

  get isTemplateAvailable(): boolean {
    return !!(this.entity && this.entity.isESETemplate);
  }

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  private openAfterDismiss(callback: () => void): void {
    this.modalService.dismissAll();
    setTimeout(() => callback(), 0);
  }

  private reopenChooser(): void {
    const chooserOptions: NgbModalOptions = {
      size: 'sm',
      windowClass: 'ese-chooser-modal-window',
      backdropClass: 'ese-chooser-modal-backdrop',
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(EseChooserModalComponent, chooserOptions);
    modalRef.componentInstance.entity = this.entity;
    modalRef.componentInstance.isFromVendorListing = this.isFromVendorListing;
    modalRef.componentInstance.selectedVendors = this.selectedVendors;
    modalRef.componentInstance.currentUser = this.currentUser;
    modalRef.componentInstance.closeEvent.subscribe(event => {
      this.closeEvent.emit(event);
    });
  }

  private handleChildClose(event: any): void {
    const isComplete = event?.isComplete || event?.eseLambdaResponse;
    if (isComplete) {
      this.closeEvent.emit(event);
    } else {
      this.reopenChooser();
    }
  }

  onUpload(): void {
    if (this.isFromVendorListing) {
      this.openAfterDismiss(() => {
        const modalRef = this.modalService.open(
          CreateEseFromTemplateModalComponent,
          this.ngbModalOptionsCreateFromTemplate
        );
        modalRef.componentInstance.entity = this.entity;
        modalRef.componentInstance.selectedVendors = this.selectedVendors;
        modalRef.componentInstance.currentUser = this.currentUser;
        modalRef.componentInstance.closeEvent.subscribe(event => this.handleChildClose(event));
      });
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      const file = input.files[0];
      this.openAfterDismiss(() => {
        const modalRef = this.modalService.open(EmergingSecurityEventModalComponent, this.ngbModalOptionsESEModal);
        modalRef.componentInstance.entity = this.entity;
        modalRef.componentInstance.isFromVendorListing = this.isFromVendorListing;
        modalRef.componentInstance.selectedVendors = this.selectedVendors;
        modalRef.componentInstance.currentUser = this.currentUser;
        modalRef.componentInstance.closeEvent.subscribe(ev => this.handleChildClose(ev));
        const interval = setInterval(() => {
          if (!modalRef.componentInstance.isLoading) {
            clearInterval(interval);
            modalRef.componentInstance.onUpload(file);
          }
        }, 100);
      });
    }
    input.value = '';
  }

  onBuild(): void {
    this.openAfterDismiss(() => {
      const modalRef = this.modalService.open(EmergingSecurityEventModalComponent, this.ngbModalOptionsESEModal);
      const entityCopy = { ...this.entity, isESETemplate: null };
      modalRef.componentInstance.entity = entityCopy;
      modalRef.componentInstance.isFromVendorListing = this.isFromVendorListing;
      modalRef.componentInstance.selectedVendors = this.selectedVendors;
      modalRef.componentInstance.currentUser = this.currentUser;
      modalRef.componentInstance.closeEvent.subscribe(event => this.handleChildClose(event));
    });
  }

  onTemplate(): void {
    this.openAfterDismiss(() => {
      const modalRef = this.modalService.open(EmergingSecurityEventModalComponent, this.ngbModalOptionsESEModal);
      modalRef.componentInstance.entity = this.entity;
      modalRef.componentInstance.isFromVendorListing = this.isFromVendorListing;
      modalRef.componentInstance.selectedVendors = this.selectedVendors;
      modalRef.componentInstance.currentUser = this.currentUser;
      modalRef.componentInstance.closeEvent.subscribe(event => this.handleChildClose(event));
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }
}
